const footerLinks = [
  {
    name: "Program Details",
    href: "https://alpha.gov.bc.ca/gov/content/environment/climate-change/industry/cleanbc-industry-fund",
  },
  {
    name: "Disclaimer",
    href: "https://www2.gov.bc.ca/gov/content/home/disclaimer",
  },
  {
    name: "Privacy",
    href: "https://www2.gov.bc.ca/gov/content/home/privacy",
  },
  {
    name: "Accessibility",
    href: "https://www2.gov.bc.ca/gov/content/home/accessible-government",
  },
  {
    name: "Copyright",
    href: "https://www2.gov.bc.ca/gov/content/home/copyright",
  },
];

export default footerLinks;
